import React, {PureComponent} from 'react'
import {Menu, Modal, Popup} from 'semantic-ui-react'
import {Link} from 'react-router-dom'
import {isAuthenticated, logout, showApiKey} from '../../services/self'
import {fetchSubscriptions, getCatalog} from '../../services/api-catalog'
import './MenuBar.css'
import LoginFromHomePage from "../../shared_states/LoginFromHomePageRequest/LoginFromHomePage";


export default class MenuBar extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: isAuthenticated(),
            apiKey: '',
        };

        getCatalog().then(catalog => {
            this.setState({catalog})
        });

        if (isAuthenticated()) {
            fetchSubscriptions().then(subscriptions => {
                this.setState({subscriptions})
            })
        }
    }

    showApiKey() {
        showApiKey().then(apiKey => {
            this.setState({apiKey})
        });
    }

    logout() {
        logout();
        this.setState({loggedOut: true});
        setTimeout(function(){
            window.location.reload();
        });
    }

    render() {

        return (<Menu secondary inverted>
            <Menu.Menu position="right">
                <Menu.Item name="home" as={Link} to="/">Home</Menu.Item>
                <Menu.Item name="getting-started" as={Link} to="/getting-started">Getting started</Menu.Item>
                {this.state.isAuthenticated ?
                    <Popup
                        trigger={<Menu.Item name="api-key" as={Link} to="#" onClick={() => this.showApiKey()}
                                            size='mini'>API Key</Menu.Item>}
                        content={this.state.apiKey ? this.state.apiKey.toString() : 'Loading API Key...'}
                        on='click'
                        positioning='bottom right'/> : ''}
                {this.state.isAuthenticated ?
                    <Menu.Item name="log-out" onClick={() => this.logout()}>Sign out</Menu.Item> : ''}
                {this.state.isAuthenticated ? '' : <Modal
                    size='small'
                    trigger={<Menu.Item id="loginButton" name="sign-in" as={Link} to="#">Sign In</Menu.Item>}>
                    <LoginFromHomePage/>
                </Modal>}
            </Menu.Menu>
        </Menu>)
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/MenuBar/index.js
 **/